/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import SuccessStar from "../../Assets/imgNewUI/SuceesStar.png";
import CheckMark from "../../Assets/imgNewUI/CheckMark.png";
import copyIcon from "../../Assets/img/copy_Image.png";
import { useNavigate } from "react-router-dom";
import { decryptAES } from "../../Common/Axios/encrypt";
import { useDispatch } from "react-redux";
import { onPostDealCodeReset } from "../../Store/Slices/dealCouponCodeSlice";
import getTranslation from "../../TranslationUtility/TranslationUtility";

const BonusRedeem = ({ postDealCouponCodeData, dealCoupon, reDirect, dealName }) => {
  const disptach = useDispatch();
  const [copied, setCopied] = useState(null);
  const translation = getTranslation();
  const isHotelMember = dealCoupon?.membershipType === translation?.membership_hotel;
  const safeDecrypt = (value) => (value ? decryptAES(value) : "");
  const couponDisplayValue = isHotelMember
    ? postDealCouponCodeData?.postDealCouponRefNoData
    : safeDecrypt(postDealCouponCodeData?.postDealCouponCodeData);
  const pinDisplayValue = safeDecrypt(postDealCouponCodeData?.postDealCouponPinData);
  const gcidDisplayValue = postDealCouponCodeData?.postDealCouponGCIDData;

  const handleCopy = (coupon, copyKey = "offer") => {
    if (coupon) {
      navigator.clipboard.writeText(coupon);
      setCopied(copyKey);
      document.body.style.overflow = "hidden";
      setTimeout(() => {
        setCopied(null);
        document.body.style.overflow = "";
      }, 3000);
    }
  };

  const navigate = useNavigate();
  const handleButtonClick = (coupon) => {
    disptach(onPostDealCodeReset());
    navigate(coupon ? "/" : -1);
  };

  // Prevent background scrolling when modal is open
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);
  console.log("postDealCouponCodeData", postDealCouponCodeData);

  return (
    <div className="modal-overlay">
      <div className="modal-container-1">
        <div className="success-icon">
          <img className="green-badge" src={SuccessStar} alt="Success" />
          <img className="checkmark" src={CheckMark} alt="checkMark" />
        </div>
        <h2 className="modal-title">
          {translation?.congratulations}
        </h2>
        {translation?.welcomeBonusRedeemed && dealCoupon?.membershipType === translation?.membership_normal &&
          <p className="modal-message">
            {translation?.welcomeBonusRedeemed}
          </p>}
        {translation?.HotelMembershipSuccessHeading && dealCoupon?.membershipType === translation?.membership_hotel &&
          <p className="modal-message-hotel">
            {translation?.HotelMembershipSuccessHeading.replace("<HotelName>", dealName)}
          </p>}
        {dealCoupon?.pendingMessage && <p className="modal-success-message">
          {dealCoupon?.pendingMessage}
        </p>}
        <div className="coupon-details-container relative">
          {copied && (
            <div className="copied-message bg-green-500">
              {translation?.copiedSuccessfully}
            </div>
          )}
          <div className="coupon-details">
            <div className="coupon-row">
              <span className="span-sec">{isHotelMember ? translation?.ClaimReferenceNo : translation?.offerCode}</span>
              <span className="copy-section">
                {couponDisplayValue}
                <button onClick={() => handleCopy(couponDisplayValue, "offer")}>
                  <img src={copyIcon} alt="Copy Icon" className="h-5 w-5" />
                </button>
              </span>
            </div>
            {(pinDisplayValue || gcidDisplayValue) &&<div className="membership-card-seprater" />}
            {pinDisplayValue && <div className="coupon-row">
              <span className="span-sec">{translation?.pinText || "Pin"}</span>
              <span className="copy-section">
                {pinDisplayValue}
                <button onClick={() => handleCopy(pinDisplayValue, "pin")}>
                  <img src={copyIcon} alt="Copy Icon" className="h-5 w-5" />
                </button>
              </span>
            </div>}
            {gcidDisplayValue && <div className="coupon-row">
              <span className="span-sec">{translation?.gcidText || "GCID"}</span>
              <span className="copy-section">
                {gcidDisplayValue}
                <button onClick={() => handleCopy(gcidDisplayValue, "gcid")}>
                  <img src={copyIcon} alt="Copy Icon" className="h-5 w-5" />
                </button>
              </span>
            </div>}
          </div>
        </div>
        <button
          className="ok-button"
          onClick={() => handleButtonClick(reDirect)}
        >
          {translation?.okLabel}
        </button>
      </div>
    </div>
  );
};

export default BonusRedeem;
